import { OperationTypeNode } from "graphql";
import resolvers from "../resolvers";
// These are the root query field names that are supported by the offline server
const OFFLINE_SUPPORTED_QUERIES = Object.keys(resolvers.Query);
const OFFLINE_SUPPORTED_MUTATIONS = Object.keys(resolvers.Mutation);
export default function isResolverAvailable(rootResolver) {
    return rootResolver.operationType === OperationTypeNode.QUERY
        ? OFFLINE_SUPPORTED_QUERIES.includes(rootResolver.operationName)
        : OFFLINE_SUPPORTED_MUTATIONS.includes(rootResolver.operationName);
}
